
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"d":"M30.5 16.672V9.5c0-.375-.328-1.5-1.5-1.5-.375 0-.703.14-.938.375l-4.03 3.188C22.061 13.155 19.531 14 17 14h-6c-1.688 0-3 1.36-3 3v4.5c0 1.688 1.313 3 3 3l-.047 1.5c0 1.875.422 3.656 1.219 5.203.234.516.75.797 1.312.797h3.47c1.218 0 1.968-1.36 1.218-2.344-.75-1.031-1.219-2.25-1.219-3.656 0-.516.094-.984.188-1.5H17c2.531 0 5.063.89 7.031 2.484l4.032 3.188c.187.187.609.328.89.328 1.172 0 1.5-1.031 1.5-1.5v-7.125c.938-.516 1.5-1.5 1.5-2.625.047-1.078-.562-2.063-1.453-2.578zM16.953 30.5h-3.469c-.656-1.406-1.03-2.906-1.03-4.453v-1.5l.046-.047h3.14c-.093.516-.187 1.031-.187 1.5 0 1.688.516 3.234 1.5 4.5zM11 23a1.48 1.48 0 01-1.5-1.5V17c0-.797.656-1.5 1.5-1.5h6V23h-6zm18 5.953c0 .047-.047.047-.047.047l-3.984-3.188c-1.875-1.5-4.125-2.39-6.469-2.671v-7.735a13.174 13.174 0 006.469-2.672l3.984-3.187H29v19.406z","fill":"#586E8C"}})])
          )
        }
      }
    